<template>
  <WhiteSection class="mb-3 pa-0">
    <v-toolbar flat color="white">
      <v-layout justify-start align-center>
        <slot />
      </v-layout>
      <v-layout justify-end align-center>
        <slot name="searchArea" />
        <v-text-field
          v-model="searchKeyword"
          :placeholder="placeholder"
          @keypress.enter="search"
          @click:append="search"
          @click:clear="onClear"
          style="max-width:265px;"
          clearable
          append-icon="search"
        />
        <PageSelect
          :value="searchResult"
          @input="$emit('pagination', $event)"
          style="width:160px;"
          class="pl-4"
        />
      </v-layout>
    </v-toolbar>
  </WhiteSection>
</template>

<script>
import PageSelect from '@/components/Shared/Search/PageSelect'
import WhiteSection from '@/components/Shared/Section/Section'

export default {
  name: 'SearchBar',
  components: {
    PageSelect,
    WhiteSection,
  },
  props: {
    keyword: {
      type: String,
      default: '',
    },
    searchResult: {
      type: Object,
      default: () => {},
    },
    placeholder: {
      type: String,
      default: '検索',
    },
  },
  computed: {
    searchKeyword: {
      get() {
        return this.keyword
      },
      set(value) {
        this.$emit('inputKeyword', value)
      },
    },
  },
  methods: {
    search() {
      this.$emit('search', this.keyword)
    },
    onClear() {
      this.$emit('inputKeyword', '')
      this.$emit('search', '')
    },
  },
}
</script>
